import { Outlet } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 8;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme, pin }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: pin ? theme.spacing(43) : theme.spacing(6),
  },
  transition: theme.transitions.create("padding-right", {
    duration: theme.transitions.duration.standard,
  }),
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  return (
    <RootStyle>
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
